module.exports = __webpack_public_path__ + "static/media/wrench.86b47b61.svg";